import React from 'react';
import classNames from 'classnames';
import styles from './CategoriesHeader.module.scss';
import { Tooltip } from 'antd';

const CategoriesHeader = ({ categories }) => (
  <div className={styles.categories_header}>
    {categories.map((category, index) => {
      let absencesMaxDays = 0;
      if (category.maxCount) {
        absencesMaxDays += category.maxCount;
      }
      if (category.nbrOfRecoveredAnnualHolidays) {
        absencesMaxDays += category.nbrOfRecoveredAnnualHolidays;
      }

      if (category.nbrOfCollaboratorWorkingDays) {
        absencesMaxDays += category.nbrOfCollaboratorWorkingDays;
      }

      if (category.nbrOfZoneWorkingDays) {
        absencesMaxDays += category.nbrOfZoneWorkingDays;
      }

      return (
        <div
          key={index}
          className={classNames({
            [styles.categories_header_item]: true,
            [styles[`${category.className}_item`]]: true
          })}
        >
          <div
            className={classNames({
              [styles.top_bar]: true,
              [styles[`${category.className}_item_top_bar`]]: true
            })}
          />
          <div
            className={classNames({
              [styles.item_count]: true,
              [styles[`${category.className}_item_count`]]: true
            })}
          >
            {absencesMaxDays > 0 ? (
              <Tooltip title={
                <ul>
                  <li>
                    {category.maxCount} jours de congé
                  </li>
                  <li>
                    {category.nbrOfRecoveredAnnualHolidays} jours récupérés
                  </li>
                  <li>
                    {(category.nbrOfCollaboratorWorkingDays  || 0) + (category.nbrOfZoneWorkingDays || 0)} jours ouvrables
                  </li>
                </ul>
              }>
                {category.count}{absencesMaxDays > 0 ? `/${absencesMaxDays}` : ''} j.
              </Tooltip>
            ) : (
              <span>{category.count} j.</span>
            )}
          </div>
          <div
            className={classNames({
              [styles.item_label]: true,
              [styles[`${category.className}_item_label`]]: true
            })}
          >
            {category.label}
          </div>
        </div>
        );
      }
    )}
  </div>
);

export default CategoriesHeader;
